import React from 'react';
import {Flex, Divider, Icon, Heading, Text, Button, Tooltip} from '@chakra-ui/react';
import {getUsername, roleContains, clearAll} from '../../helpers/localStorage';
import {FaSignOutAlt} from 'react-icons/fa';
import {useNavigate} from 'react-router-dom';

const UserWidget = ({navSize}) => {
  const username = getUsername();
  const navigate = useNavigate();

  const RoleList = () => {
    return (
      <>
        {roleContains('admin') && <AdminRole />}

        {roleContains('sales') && <SalesRole />}

        {roleContains('data') && <DataRole />}
      </>
    );
  };

  const AdminRole = () => {
    return <Text color="gray.500">Admin</Text>;
  };

  const SalesRole = () => {
    return <Text color="gray.500">Sales</Text>;
  };

  const DataRole = () => {
    return <Text color="gray.500">Data Entry</Text>;
  };

  const Logout = () => {
    clearAll();
    navigate('/login', {replace: true});
  };

  return (
    <Flex p="5%" flexDir="column" w="100%" alignItems={navSize == 'small' ? 'center' : 'flex-start'} mb={4}>
      <Divider display={navSize == 'small' ? 'none' : 'flex'} />
      <Flex mt={4} align="center">
        <Tooltip label="Logout">
          <Button _hover={{textDecor: 'none', backgroundColor: 'secondary.100'}} bg="transparent" title="Logout" onClick={Logout}>
            <Icon as={FaSignOutAlt} color={'graystone.primary'} mx="-1" my="2" />
          </Button>
        </Tooltip>
        <Flex flexDir="column" ml={4} display={navSize == 'small' ? 'none' : 'flex'}>
          <Heading as="h3" size="sm">
            {username}
          </Heading>
          <RoleList />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default UserWidget;
